const apiUrl = process.env.REACT_APP_API_URL;
const kpiUrl = process.env.REACT_APP_KPI_URL;
const ktickUrl = process.env.REACT_APP_KTICK_URL;
const productName = process.env.REACT_APP_PRODUCT_NAME; 
const recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY;
const kubuniImagesUrl = process.env.REACT_APP_KUBUNI_IMAGES_URL;
const mapZoom = 10;

let documentsUrl = '';

if (process.env.NODE_ENV === 'production') {
    documentsUrl = window.location.origin+'/documents/'; // Redirected with AliasMatch "^/documents/(.*)$" "/var/www/html/monresto-api/project/public/pizzeria-des-bois/$1"

} else {
    documentsUrl = 'http://localhost:8008/pizzeria-des-bois/';
}

const config = {
  apiUrl: apiUrl,
  kpiUrl: kpiUrl,
  ktickUrl: ktickUrl,
  productName: productName,
  recaptchaKey: recaptchaKey,
  kubuniImagesUrl: kubuniImagesUrl,
  mapZoom: mapZoom,
  documentsUrl: documentsUrl
};

export default config;
